/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, CircularProgress, InputLabel,IconButton, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { LeftSide, LoginContainer, RightSide } from "./LoginStyle";
import { useForm, Controller } from "react-hook-form";
import { loginSchema } from "../../../schemas/LoginSchema"
import { yupResolver } from '@hookform/resolvers/yup';
import InputController from "../../../components/InputController/InputController";
import { useNavigate } from "react-router";
import PATH from "../../../router/params";
import useMasterApi from "../../../services/useMasterApi";
import { ENDPOINT } from "../../../services/endPoints";
import useToast from "../../../hooks/useToast";
import CustomToast from "../../../components/Toast/CustomToast";
import PasswordReset from "../PasswordReset/PasswordReset";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormControl from "@mui/material/FormControl";

const LoginScreen = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = React.useState(false);

  const {post, data, error, loading} = useMasterApi();
  const { toastMessage, toast, toastType, setToast, showToast } = useToast()
  const [isPasswordReset, setIsPasswordReset] = useState(false);
  const { handleSubmit, control, formState: {errors}, reset} = useForm({
    defaultValues:{
      hospital_email_id: "",
      password: ""
    },
    resolver: yupResolver(loginSchema),
  });

  useEffect(()=>{
    if(localStorage.getItem("email")){
      localStorage.removeItem("email")
    }
  },[])

  
  const onSubmit = async (form_data)=>{
    await post(ENDPOINT.HOSPITAL_LOGIN, form_data); 
    reset();   
  }

  useEffect(()=>{
    if(data){
      if(data.success){
        showToast("success", "Login Successfully")
        localStorage.setItem("token", data.data.token);
        localStorage.setItem("hospitalId", JSON.stringify(data.data.user.hospital_id));
        localStorage.setItem("hospital", JSON.stringify(data.data.user));
        setTimeout(()=>{
          navigate(PATH.HOME, {replace: true});
        },1500)
        
      }
      if(error){
        showToast("error", error.data.error)
      }
    }
  },[data, error])

  const handlePasswordReset = () =>{
    setIsPasswordReset(!isPasswordReset);
  }

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };


  return (
    <>
    <LoginContainer>
    <RightSide>
      <Box sx={{ height:"100%", display:"flex", flexDirection: "column", width:"100%",  alignItems:"center", gap: "2rem"  }}>
      <Box component="img" src="/assets/images/logo.png" alt="Ministry of Health Logo" style={{ width: "125px", height: "96px" }}/>
      </Box>
    </RightSide>


      <LeftSide>
        <Box sx={{ height:"100%", width: "100%", position:"relative" }}>
          {!isPasswordReset ? <form onSubmit={handleSubmit(onSubmit)}>
            <Box sx={{ display:"flex", flexDirection: "column", gap: "1rem", maxWidth:"550px", mx:"auto" }}>
               <Box sx={{textAlign:"center"}}>
                   <Typography variant="h1" fontWeight="bold" color={(theme)=>theme.palette.secondary.main}>
                      Welcome
                   </Typography>
                <Typography variant="h2" sx={{mt:3.5, lineHeight: "1.5", fontWeight:"600" }} >
                ESWATINI DIABETIC EYE AND FOOT SCREENING (EDEFS) IMAGE MANAGEMENT AND REPORTING PORTAL 
                {/* Eswatini Diabetic Eye & Foot Screening (EDEFS) Image Management & Reporting Portal */}
                 </Typography>
            </Box> 
                <InputLabel sx={{mt:4.5, fontSize: "1.5rem",  color:(theme)=>theme.palette.primary.main}}>Login Your Account</InputLabel>
                   <InputController
                     name="hospital_email_id"
                     label="Email"
                     control={control}
                     errors={errors}
                     mainLogin
                     />

          <FormControl sx={{  width: "inherit" }} variant="outlined">
                <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                <Controller
                  name="password"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <OutlinedInput
                      {...field}
                      fullWidth
                      id="outlined-adornment-password"
                      type={showPassword ? "text" : "password"}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                      label="Password"
                    />
                  )}
                />
              </FormControl>

                <Button type="submit" disabled={loading} variant="contained" fullWidth sx={{mt:2}}> {loading ? <CircularProgress/> : "Login"}</Button>
                     <Typography variant="body2" color="error" sx={{textAlign:"right", cursor: "pointer",
                         }} onClick={handlePasswordReset}>
                     Forgot Password?
                     </Typography>
             </Box>
          </form> : <PasswordReset isReset={isPasswordReset} handlePasswordReset={handlePasswordReset}/>}
        </Box>
        <Typography variant="h1" color={(theme)=>theme.palette.secondary.main}>REFERRAL FACILITY
    </Typography>
      </LeftSide>
      {toast && <CustomToast 
        open={toast}
        toastMessage={toastMessage}
        setToast={setToast}
        toastType={toastType}
      />}
    </LoginContainer>
    </>
  );
};

export default LoginScreen;
